export default "__VITE_ASSET__C8S$TCse__"